module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg-gray"
  }, [_c('banner-bg', {
    attrs: {
      "title": "查询",
      "subtitle": "Search",
      "src": require('@/assets/images/mainindex/pic-cha.png')
    }
  }), _vm._v(" "), _c('special-tabs', {
    staticClass: "special-box",
    attrs: {
      "activeName": _vm.activeName,
      "tabList": _vm.tabList
    },
    on: {
      "onClick": _vm.onClick
    }
  }), _vm._v(" "), _c('cha-person', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == '个人查询'),
      expression: "activeName=='个人查询'"
    }],
    attrs: {
      "activeName": _vm.activeName,
      "areaOptions": _vm.areaOptions
    }
  }), _vm._v(" "), _c('cha-danwei', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == '单位查询'),
      expression: "activeName=='单位查询'"
    }],
    attrs: {
      "activeName": _vm.activeName,
      "areaOptions": _vm.areaOptions
    }
  }), _vm._v(" "), _c('cha-caipan', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == '裁判员查询'),
      expression: "activeName=='裁判员查询'"
    }],
    attrs: {
      "activeName": _vm.activeName,
      "areaOptions": _vm.areaOptions
    }
  }), _vm._v(" "), _c('cha-jiaolian', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == '教练员查询'),
      expression: "activeName=='教练员查询'"
    }],
    attrs: {
      "activeName": _vm.activeName,
      "areaOptions": _vm.areaOptions
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-812c4f5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/Cha.vue
// module id = 1545
// module chunks = 0